import { useLanguage } from "@/lib/i18n";
import { homeFaq } from "@/data/homeFaq";
import { FaqAccordion } from "@/components/content/blocks";

export function HomeFAQ() {
  const { language } = useLanguage();
  const title =
    language === "fr" ? "Questions fréquentes" : "Frequently asked questions";

  return (
    <section className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <FaqAccordion title={title} items={homeFaq[language]} />
      </div>
    </section>
  );
}
